import { FieldValues } from 'react-hook-form'

import { CODELIST } from '@isdd/metais-common/api'
import { CiTypePreview } from '@isdd/metais-common/api/generated/types-repo-swagger'
import { IFilterParams } from '@isdd/metais-common/hooks/useFilter'

export interface EntityFilterData extends IFilterParams, FieldValues {
    name?: string
    technicalName?: string
    type?: string
    valid?: string
}

enum KeysToCompare {
    TECHNICAL_NAME = 'technicalName',
    NAME = 'name',
}

export const DIACRITICS = {
    a: '[aÀÁÂÃÄÅàáâãäå]',
    c: '[cÇçćĆčČ]',
    d: '[dđĐďĎ]',
    e: '[eÈÉÊËèéêëěĚ]',
    i: '[iÌÍÎÏìíîï]',
    l: '[ĺľĹĽ]',
    n: '[nÑñňŇ]',
    o: '[oÒÓÔÕÕÖØòóôõöø]',
    r: '[rřŘŕŔ]',
    s: '[sŠš]',
    t: '[tťŤ]',
    u: '[uÙÚÛÜùúûüůŮ]',
    y: '[yŸÿýÝ]',
    z: '[zŽž]',
}

const escape_regex = (str: string) => {
    return (str + '').replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1')
}

export const removeInvalidURLSymbols = (input: string): string => {
    const regex = /[^A-Za-z0-9_.~]+/g

    return input.replace(regex, '')
}

export const latinizeString = (str: string, omitLowerCase = false) => {
    let escapedText = omitLowerCase ? escape_regex(str) : escape_regex(str).toLowerCase()

    const dialectValues = Object.entries(DIACRITICS)

    dialectValues?.map(([key, value]) => {
        escapedText = escapedText.replace(new RegExp(value, omitLowerCase ? 'gi' : 'g'), (match) => {
            return match === match.toUpperCase() ? key.toUpperCase() : key
        })
    })
    return escapedText
}

const compareStrings = (data: CiTypePreview[] | undefined, valueToFind: string, keyToCompare: KeysToCompare) => {
    const latinizedValueToFind = latinizeString(valueToFind)

    return (
        data?.filter((value) => {
            const latinisedDataName = latinizeString(value?.[keyToCompare] ?? '')
            return latinisedDataName?.includes(latinizedValueToFind)
        }) ?? []
    )
}

const fromStringToBoolean = (val: string) => (val == 'false' || val === '' ? false : true)

export const filterEntityData = (filter: EntityFilterData, data: CiTypePreview[] | undefined) => {
    let newData = [...(data ?? [])]
    if (filter?.name) {
        newData = compareStrings(newData, filter?.name, KeysToCompare.NAME)
    }
    if (filter?.fullTextSearch) {
        newData = compareStrings(newData, filter?.fullTextSearch, KeysToCompare.NAME)
    }
    if (filter?.technicalName) {
        newData = compareStrings(newData, filter?.technicalName, KeysToCompare.TECHNICAL_NAME)
    }
    if (filter?.type) {
        if (filter.type === CODELIST) {
            newData = newData?.filter((val) => val?.labels?.includes(CODELIST))
        } else {
            newData = newData?.filter((val) => val?.type === filter?.type && !val?.labels?.includes(CODELIST))
        }
    }
    if (filter?.valid) {
        const validToBoolean = fromStringToBoolean(filter?.valid)
        newData = newData?.filter((val) => val?.valid === validToBoolean)
    }
    return newData
}
